(function () {
  "use strict";

  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  const forms = document.querySelectorAll(".needs-validation");

  // Loop over them and prevent submission
  Array.prototype.slice.call(forms).forEach(function (form) {
    form.addEventListener(
      "submit",
      function (event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }

        form.classList.add("was-validated");

        // for contact-form-maps
        let errorSection = document.querySelector(
          ".contact-form-maps .error-section ul"
        );
        if (errorSection) {
          errorSection.style.display = "block";
          let errors = document.querySelectorAll(
            ".contact-form-maps .was-validated :invalid ~ .invalid-feedback"
          );
          errorSection.innerHTML = "<li>Errors: </li>";
          errors.forEach((item) => {
            const li = document.createElement("li");
            li.append(item.innerText);
            errorSection.append(li);
          });
        }
      },
      false
    );
  });
  let submitBtn = document.querySelector(".submit-btn");
  const checkbox = document.querySelector(".agree-checkbox");

  if (checkbox) {
    checkbox.addEventListener("change", (event) => {
      if (event.currentTarget.checked) {
        submitBtn.classList.remove("disabled");
      } else {
        submitBtn.classList.add("disabled");
      }
    });
  }
})();
